<p-panel header="Basisdaten">
	<his-plam helptext="{{'cm.stu.reqmanagement.AbstractRequest.receiptdate.helptext' | hisUi}}">
		<input hisDdKey="cm.stu.reqmanagement.AbstractRequest.receiptdate" #content 
				[(ngModel)]="request.receiptdate" class="inputWidth100" disabled>
	</his-plam>
	<his-plam helptext="{{'cm.stu.reqmanagement.AbstractRequest.changedate.helptext' | hisUi}}">
		<input hisDdKey="cm.stu.reqmanagement.AbstractRequest.changedate" #content 
				[(ngModel)]="request.changedate" class="inputWidth100" disabled>
	</his-plam>
	<his-plam helptext="{{'cm.stu.reqmanagement.AbstractRequest.inboxdate.helptext' | hisUi}}">
		<p-calendar hisDdKey="cm.stu.reqmanagement.AbstractRequest.inboxdate" #content [(ngModel)]="request.inboxdate"></p-calendar>
	</his-plam>
	<his-plam helptext="{{'cm.stu.reqmanagement.AbstractRequest.signdate.helptext' | hisUi}}">
		<p-calendar hisDdKey="cm.stu.reqmanagement.AbstractRequest.signdate" #content [(ngModel)]="request.signdate"></p-calendar>
	</his-plam>
	<his-plam helptext="{{'cm.stu.reqmanagement.AbstractRequest.approvalStatusValue.helptext' | hisUi}}">
		<p-autoComplete #content [dropdown]="true" hisDdKey="cm.stu.reqmanagement.AbstractRequest.approvalStatusValue" 
			[(ngModel)]="request.approvalStatusValue" [suggestions]="approvalResults" (completeMethod)="searchApproval($event)"> <!-- hisEagerDataSource="requestApprovalStatusValueDao" -->
		</p-autoComplete>
	</his-plam>
    <his-plam helptext="{{'cm.stu.reqmanagement.AbstractRequest.reasonForRejection.helptext' | hisUi}}">
		<p-multiSelect hisDdKey="cm.stu.reqmanagement.AbstractRequest.reasonForRejection" #content 
			[options]="reasonsForRejection" [(ngModel)]="request.reasonForRejection" optionLabel="text"></p-multiSelect>
	</his-plam>
	<his-plam helptext="{{'cm.stu.reqmanagement.AbstractRequest.processingStatusValue.helptext' | hisUi}}">
		<p-autoComplete #content [dropdown]="true" hisDdKey="cm.stu.reqmanagement.AbstractRequest.processingStatusValue" 
			[(ngModel)]="request.processingStatusValue" [suggestions]="processingResults" (completeMethod)="searchProcessing($event)"> <!-- hisEagerDataSource="requestProcessingStatusValueDao" -->
		</p-autoComplete>
	</his-plam>
	<his-plam>
		<textarea hisDdKey="cm.stu.reqmanagement.AbstractRequest.commentaryInternal" #content [(ngModel)]="request.commentaryInternal" rows="4" class="textareaWidth100"></textarea>
	</his-plam>
	<his-plam>
		<textarea hisDdKey="cm.stu.reqmanagement.AbstractRequest.commentaryApplicant" #content [(ngModel)]="request.commentaryApplicant" rows="4" class="textareaWidth100"></textarea>
	</his-plam>
</p-panel>
